import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=7bb8b6e7"
import script from "./attribute.vue?vue&type=script&lang=js"
export * from "./attribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports